'use strict';

var loadFacebookChunk = require('promise?global,facebook!../chunks/facebook');

function FacebookDialogError() {}
FacebookDialogError.prototype = Object.create(Error.prototype);

var didInit = false;

function prepareSDK() {
  return loadFacebookChunk().then(chunk => {
    var fb = chunk.facebook;
    if (!didInit) {
      fb.init({
        appId: '419123104792477',
        version: 'v2.0',
        status: true
      });
      didInit = true;
    }

    return fb;
  });
}

var FacebookManager = {
  init() {
    prepareSDK();
  },

  showFacebookSendDialog(invite) {
    var link = invite.link,
        userId = invite.serviceId;

    return prepareSDK().then(fb => {
      return new Promise(function (resolve, reject) {

        // Scraping may help Facebook pick up the link: http://stackoverflow.com/a/18217741/458193
        // No guarantees though.

        fb.api('https://graph.facebook.com/', 'post', {
          id: link,
          scrape: true
        }, function () {
          fb.ui({
            display: 'iframe',
            to: userId,
            method: 'send',
            link: link
          }, function (response) {
            if (response && response.success) {
              resolve();
            } else {
              reject(new FacebookDialogError());
            }
          });
        });
      });
    });
  }
};

module.exports = FacebookManager;


/** WEBPACK FOOTER **
 ** ./utils/FacebookManager.js
 **/